import React from 'react'
import Modal from 'react-bootstrap/lib/Modal'
import { appNums } from "../../common/nums/app_nums"
const { MIN_PASSWORD_LENGTH } = appNums
class PasswordModal extends React.Component {
    constructor(props) {
        super(props)

        this.handleClose = this.handleClose.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.validate = this.validate.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.state = {
            currentPass: '',
            newPass: '',
            confirmPass: '',
            allFieldsValid: false,
        }
    }

    handleClose() {
        this.props.closePasswordModal()
    }

    handleChange(e) {
        const { name, value } = e.target
        this.setState({ [name]: value }, () => this.validate({...this.state,[name]: value}))
    }

    validate(newState) {
        const {currentPass, newPass, confirmPass} = newState
        const confirm = newPass === confirmPass
        const nonEmpty = (currentPass !== '') && (confirmPass !== '')
        const properLength = currentPass >= MIN_PASSWORD_LENGTH
        const isValid = nonEmpty && confirm && properLength
        this.setState({allFieldsValid: isValid})
    }

    handleSubmit() {
        const { currentPass, newPass } = this.state
        this.props.changePassword(currentPass, newPass)
        this.setState({currentPass: ''})
        this.focus()
    }

    focus() {
        this.input.focus()
    }

    render() {
        const {
            currentPass,
            newPass,
            confirmPass,
            allFieldsValid,
        } = this.state
        const { pwModalOpen } = this.props

        const passwordInput = (name, value, fieldName) => {
            return (
                <div className="form-group">
                    <label>{fieldName}</label>
                    <input
                        type="password"
                        className="form-control"
                        name={name}
                        value={value}
                        onChange={this.handleChange}
                    />
                </div>
            )
        }

        return (
            <div>
                <Modal show={pwModalOpen} onHide={this.handleClose} className="password-modal-container modal-v2">
                    <Modal.Header closeButton>
                        <Modal.Title>Change Password</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="password-modal-body">
                        <div className="password-modal-content">
                            <div className="form-group">
                                <label>Current Password</label>
                                <input
                                    ref={input => this.input = input}
                                    autoFocus={true}
                                    type="password"
                                    className="form-control"
                                    name={"currentPass"}
                                    value={currentPass}
                                    onChange={this.handleChange}
                                />
                            </div>
                            {passwordInput("newPass", newPass, "New Password")}
                            {passwordInput("confirmPass", confirmPass, "Confirm Password")}
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="password-modal-footer">
                        <button className="btn btn-default btn-spacer" type="button" onClick={this.handleClose}>Cancel</button>
                        <button
                            disabled={!allFieldsValid}
                            className="btn btn-primary btn-spacer"
                            type="button"
                            onClick={this.handleSubmit}
                        >
                            Change Password
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
export default PasswordModal


// WEBPACK FOOTER //
// ./src/components/modals/password_modal.jsx